import React, {useEffect, useState} from 'react';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import { actionsType } from 'config/constants';
import ShopTogether from 'components/Product/ShopTogether';
import style from './style.scss'; //NOSONAR

let actions = [];
const ModalShopTogether = () => {

    const [payload, setPayload] = useState(null);

    
    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.SHOP_TOGETHER_OPEN, openModal));
        
        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];   
        }
    }, []);

    const openModal = (_payload) => {
        setPayload(_payload.value);
    }

    return (
        <Modal customClass={'modal-shop-together'} actionOpen={actionsType.MODAL.SHOP_TOGETHER_OPEN} actionClose={actionsType.MODAL.SHOP_TOGETHER_CLOSE}>
            {payload && <ShopTogether allProducts={payload}  viewAll={true}/>}
        </Modal>
    )
}

export default ModalShopTogether;
